/* global __webpack_init_sharing__, __webpack_share_scopes__ */
import React from 'react';
import { Spinner } from '@sorted/sorted-ui';
import useDynamicScript from '../../hooks/useDynamicScript';
import ErrorPage from '../../pages/ErrorPage';

// code in here based on https://github.com/module-federation/module-federation-examples/blob/master/advanced-api/dynamic-remotes/app1/src/App.js
// and cloned in from code when it was written for webpack5 beta 25

const loadComponent = (scope, module) => async () => {
	// Initializes the share scope. This fills it with known provided modules from this build and all remotes
	await __webpack_init_sharing__('default');

	const container = window[scope];

	// Initialize the container, it may provide shared modules
	await container.init(__webpack_share_scopes__.default);

	const factory = await window[scope].get(module);
	const Module = factory();
	return Module;
};

const RemoteLoader = ({ url, scope, module, componentProps }) => {
	const { ready, failed } = useDynamicScript(url);

	if (failed) {
		return (
			<ErrorPage heading="Something went wrong." action="reload">
				<p>This page failed to load</p>
			</ErrorPage>
		);
	}

	if (!ready) {
		return <Spinner />;
	}

	const Component = React.lazy(loadComponent(scope, module));

	return (
		<React.Suspense fallback={<Spinner />}>
			<Component {...componentProps} />
		</React.Suspense>
	);
};

export default RemoteLoader;
